export const LABS_SUPPORT_URLS = [
    "/labs/:city/search",
    "/labs/:city/diagnostic-centers/:labName",
    "/labs/category/:package",
    "/labs/tests",
    "/labs",
    "/labs/test/:test_id",
    "/labs/test/:test_id/:city_name/price",
    "/labs/cart/checkout/success",
    "/labs/mybookings",
]
